import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import AccountTable from './shared/AccountTable';
import CustomerCard from './shared/CustomerCard';
import { useSelector } from 'react-redux';
import AddVendorCard from './shared/AddVendorCard';
import AddEmployeeCard from './shared/AddEmployeeCard';
import { useState } from 'react';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const AccountMaster = () => {
  const { accountType } = useSelector((state) => state.account);
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {accountType.toLowerCase() === 'customer' && (
              <CustomerCard handleApiCall={handleApiCall} />
            )}
            {accountType.toLowerCase() === 'vendor' && (
              <AddVendorCard handleApiCall={handleApiCall} />
            )}
            {accountType.toLowerCase() === 'employee' && (
              <AddEmployeeCard handleApiCall={handleApiCall} />
            )}
            <AccountTable apiCall={apiCall} setApiCall={setApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default AccountMaster;
